// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vw-8";
export var editMode = "_vw-3";
export var headerRow = "_vw-a";
export var headerTitle = "_vw-b";
export var product = "_vw-1";
export var productDetails = "_vw-5";
export var productDivider = "_vw-7";
export var productImage = "_vw-2";
export var productInfo = "_vw-4";
export var productTitle = "_vw-6";
export var strikethrough = "_vw-9";
export var upsellProductsCard = "_vw-0";